var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title + ' - ' + (_vm.$store.state.config.system_name || 'Picture')),expression:"$route.meta.title + ' - ' + ($store.state.config.system_name || 'Picture')"}]}),(_vm.isAccount)?_c('Account'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }